import { Box, DialogContent, DialogTitle } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { invalidateProductCatalogCache } from "api/cached";
import { AddProduct as AddProductModel } from "api/models/request/product/product";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { productFormSchema } from "../schema";

export const AddProduct = observer(() => {
  const queryClient = useQueryClient();
  const {
    productManagement: { openNew, setProp, getProducts },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<AddProductModel>(productFormSchema(), {
    code: "",
    name: "",
    barcode: "",
    unitOfCalculation: "",
    customerId: "",
    isDisabled: false,
  });

  const saveHandler = useCallback(
    async (data: AddProductModel) => {
      await productBussiness.add(data);
      await invalidateProductCatalogCache(queryClient);
      await getProducts();
      setProp("openNew", false);
    },
    [getProducts, queryClient, setProp],
  );

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => {
        submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm mặt hàng</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});

